export default __webpack_public_path__ + "static/media/network.148f4c13.jpg";